(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.initialState = initialState || [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.score = 0;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                if (this.canMove()) this.doMove("left");
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                if (this.canMove()) this.doMove("right");
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                if (this.canMove()) this.doMove("up");
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                if (this.canMove()) this.doMove("down");
            }
        },
        {
            key: "doMove",
            value: function doMove(direction) {
                var _this = this, _loop = function(i) {
                    var row = board[i].filter(function(cell) {
                        return cell !== 0;
                    });
                    var j = 0;
                    while(j < row.length - 1){
                        if (row[j] === row[j + 1]) {
                            row[j] *= 2;
                            _this.score += row[j];
                            row.splice(j + 1, 1);
                        }
                        j++;
                    }
                    while(row.length < 4)row.push(0);
                    board[i] = row;
                };
                var previousState = JSON.stringify(this.getState());
                var board = JSON.parse(JSON.stringify(this.getState()));
                if (direction === "up" || direction === "down") board = this.transposeBoard(board);
                if (direction === "right" || direction === "down") board = board.map(function(row) {
                    return row.slice().reverse();
                });
                for(var i = 0; i < 4; i++)_loop(i);
                if (direction === "right" || direction === "down") board = board.map(function(row) {
                    return row.slice().reverse();
                });
                if (direction === "up" || direction === "down") board = this.transposeBoard(board);
                this.setState(board);
                if (previousState !== JSON.stringify(this.getState())) {
                    this.status = "playing";
                    this.getRandomFreePosition();
                    this.checkGameStatus();
                }
            }
        },
        {
            key: "checkGameStatus",
            value: function checkGameStatus() {
                if (this.getState().some(function(row) {
                    return row.some(function(cell) {
                        return cell === 2048;
                    });
                })) {
                    this.status = "win";
                    return;
                }
                var boardFull = this.getState().every(function(row) {
                    return row.every(function(cell) {
                        return cell !== 0;
                    });
                });
                if (boardFull && !this.canMove()) this.status = "lose";
            }
        },
        {
            key: "updateGameStatus",
            value: function updateGameStatus() {
                var gameStatus = this.getStatus();
                var messageStart = document.querySelector(".message-start");
                var messageWin = document.querySelector(".message-win");
                var messageLose = document.querySelector(".message-lose");
                var startButton = document.querySelector(".start");
                messageStart.classList.add("hidden");
                messageWin.classList.add("hidden");
                messageLose.classList.add("hidden");
                if (gameStatus === "idle") {
                    messageStart.classList.remove("hidden");
                    startButton.classList.remove("restart");
                    startButton.textContent = "Start";
                } else if (gameStatus === "win") {
                    messageWin.classList.remove("hidden");
                    startButton.classList.add("restart");
                    startButton.textContent = "Restart";
                } else if (gameStatus === "lose") {
                    messageLose.classList.remove("hidden");
                    startButton.classList.add("restart");
                    startButton.textContent = "Restart";
                } else if (gameStatus === "playing") {
                    startButton.classList.add("restart");
                    startButton.textContent = "Restart";
                }
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getRandomFreePosition",
            value: function getRandomFreePosition() {
                var firstNumber, secondNumber;
                do {
                    firstNumber = Math.floor(Math.random() * 4);
                    secondNumber = Math.floor(Math.random() * 4);
                }while (this.initialState[firstNumber][secondNumber]);
                this.initialState[firstNumber][secondNumber] = this.generateRandomNumber();
            }
        },
        {
            key: "generateRandomNumber",
            value: function generateRandomNumber() {
                var probOf2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0.9;
                var random = Math.random();
                if (random <= probOf2) return 2;
                else return 4;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.initialState;
            }
        },
        {
            key: "setState",
            value: function setState(newState) {
                this.initialState = newState;
            }
        },
        {
            key: "canMove",
            value: function canMove() {
                var board = this.getState();
                for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++){
                    if (board[i][j] === 0) return true;
                }
                for(var i1 = 0; i1 < 4; i1++)for(var j1 = 0; j1 < 3; j1++){
                    if (board[i1][j1] === board[i1][j1 + 1]) return true;
                }
                for(var i2 = 0; i2 < 3; i2++)for(var j2 = 0; j2 < 4; j2++){
                    if (board[i2][j2] === board[i2 + 1][j2]) return true;
                }
                return false;
            }
        },
        {
            key: "updateView",
            value: function updateView(htmlBoard) {
                var board = this.getState();
                for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++){
                    var cell = htmlBoard.rows[i].cells[j];
                    cell.textContent = "";
                    cell.className = "field-cell";
                    if (board[i][j] !== 0) {
                        cell.textContent = board[i][j];
                        cell.classList.add("field-cell--" + board[i][j]);
                    }
                }
                var scoreElement = document.querySelector(".game-score");
                if (scoreElement) scoreElement.textContent = this.getScore();
                this.updateGameStatus();
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                this.status = "playing";
                this.getRandomFreePosition();
                this.getRandomFreePosition();
            }
        },
        {
            key: "transposeBoard",
            value: function transposeBoard(board) {
                var size = board.length;
                var transposed = Array(size).fill().map(function() {
                    return Array(size).fill(0);
                });
                for(var i = 0; i < size; i++)for(var j = 0; j < size; j++)transposed[i][j] = board[j][i];
                return transposed;
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.initialState = [
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                this.score = 0;
                this.status = "idle";
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$gameField = document.querySelector("tbody");
var $197cd56b15c33885$var$button = document.querySelector(".button");
document.addEventListener("keydown", $197cd56b15c33885$var$clickHandler);
$197cd56b15c33885$var$button.addEventListener("click", $197cd56b15c33885$var$startHandler);
function $197cd56b15c33885$var$startHandler() {
    if ($197cd56b15c33885$var$button.classList.contains("restart")) {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$game.updateView($197cd56b15c33885$var$gameField);
    } else {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$game.updateView($197cd56b15c33885$var$gameField);
    }
}
function $197cd56b15c33885$var$clickHandler(event) {
    switch(event.key){
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            $197cd56b15c33885$var$game.updateView($197cd56b15c33885$var$gameField);
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            $197cd56b15c33885$var$game.updateView($197cd56b15c33885$var$gameField);
            break;
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            $197cd56b15c33885$var$game.updateView($197cd56b15c33885$var$gameField);
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            $197cd56b15c33885$var$game.updateView($197cd56b15c33885$var$gameField);
            break;
    }
}
var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();

})();
//# sourceMappingURL=index.f13fc08c.js.map
